import { render, staticRenderFns } from "./ForeignInfo.vue?vue&type=template&id=369c3900&scoped=true&"
import script from "./ForeignInfo.vue?vue&type=script&lang=js&"
export * from "./ForeignInfo.vue?vue&type=script&lang=js&"
import style0 from "./ForeignInfo.vue?vue&type=style&index=0&id=369c3900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c3900",
  null
  
)

export default component.exports